
<template>
  <div class="activity-area" :style="{ width: seatAreaWidthRem * 2.5 + 'rem', height: seatAreaHeightRem + 'rem' }">
    <div class="screen">
      <div class="screen-text-t"> 银幕方向 </div>
    </div>
    <div class="screen-text-top">
      <div v-if="propHallName.length > 0 && showTag" class="screen-text"> 您选择的是<span style="color: #CD4B44;">{{
        propHallName
      }}</span>的场次
      </div>
    </div>
    <div class="thumbnail" v-show="thumbnailShow"
      :style="{ transform: 'scale(' + seatScale + ')', width: thumbnailWidthRem * 2.5 + 'rem', height: thumbnailHeighthRem * 2.5 + 'rem' }">
      <!--红色外框开始-->
      <div class="thumbnail-border"
        :style="{ transform: 'scale(' + scalereciprocal + ')', top: topthumbnail + 'rem', left: leftthumbnail + 'rem' }">
      </div>
      <!--红色外框结束-->
      <slot name="thumbnail-seat-solt">
        <!--这里是缩略图中的所有座位放入此插槽-->
      </slot>
    </div>
    <v-touch @pinchout="pinchout" @pinchin="pinchin" @panmove="panmove" @panstart="panstart" @panend="panend" class="box"
      ref="pinchAndPan" :pinch-options="{ threshold: 0.09 }" :pan-options="{ threshold: 0.01 }" :style="{
        transform: 'scale(' + scale + ')', transformOrigin: transformOrigin, top: top * 2.5 + 'rem', left: left + 'rem',
        width: seatAreaWidthRem * 2.5 + 'rem', height: seatAreaHeightRem * 2.5 + 'rem'
      }">
      <slot name="seat-area-solt">
        <!--所有可以点击座位的数据会放入此插槽,此插槽可以缩放,拖动-->
      </slot>
    </v-touch>
    <!--座位左边栏   ,marginTop: (9.5-scale*2)+'rem'  -->
    <div class="seat-tool-parent" :style="{ height: seatAreaHeightRem / 2 + 'rem' }">
      <div class="seat-tool" :style="{
        transform: 'scale(' + seatScale + ')', transformOrigin: transformOriginTool, marginTop: seatToolMargin * 2.5 + 'rem',
      }">
        <div v-for="(item, index) in seatToolArr" :key="'tool-' + index">
          <div class="seat-tool-item"
            :style="{ height: seatHeightWithScale * 2.5 + 'rem', width: seatToolWidthWithScale * 5 + 'rem', lineHeight: seatHeightWithScale * 2.5 + 'rem', fontSize: seatToolFontSize * 2.5 + 'rem' }">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SeatArea',
  props: {
    propThumbnailAreaWidth: Number,
    propThumbnailAreaHeight: Number,
    propYMax: Number,
    propSeatScale: Number,
    propSeatHeight: Number,
    propSeatAreaWidthRem: Number,
    propSeatAreaHeightRem: Number,
    propMiddleLine: Number,
    propHorizontalLine: Number,
    propSeatBoxHeight: Number,
    propSeatToolArr: Array,
    propHallName: String
  },
  data: function () {
    return {
      showTag: false,
      scale: 1, // 区域放大尺寸
      top: 0, // 单位rem
      left: 0, // 单位rem
      topthumbnail: 0, // 单位rem
      leftthumbnail: 0, // 单位rem
      startX: 0, // ---移动的起点X轴 单位px
      startY: 0, // ---移动的起点Y轴 单位px
      seatAreaWidthRem: this.propSeatAreaWidthRem, // 座位区域宽  rem
      seatAreaHeightRem: this.propSeatAreaHeightRem, // 座位区域高  rem
      thumbnailWidthRem: this.propThumbnailAreaWidth, // 缩略图宽 rem
      thumbnailHeighthRem: this.propThumbnailAreaHeight, // 缩略图高 rem
      middleLine: this.propMiddleLine,
      horizontalLine: this.propHorizontalLine,
      // 最大排数
      yMax: this.propYMax,
      // 内部座位图缩放比例(为了一次可以显示全部座位)
      seatScale: this.propSeatScale,
      // 项目 rem计算值
      pxtorem: 75,
      // 设备 rem计算值
      screenRem: (document.body.clientWidth || window.innerWidth || document.documentElement.clientWidth) / 10,
      // 缩略图是否显示
      thumbnailShow: false,
      // 定时器对象
      timer: {},
      // 每个座位dom的高度
      seatHeight: this.propSeatHeight,
      // .seatBox的高度
      seatBoxHeight: this.propSeatBoxHeight,
      // 触摸状态
      touchStatus: false,
      // 座位左边栏的数组
      seatToolArr: this.propSeatToolArr
    }
  },
  methods: {
    // 第一次点击座位改变放大比例
    changeScale: function () {
      if (this.maxscale === 1) {
        return
      }
      this.scale = this.maxscale
    },
    // 第一次点击座位改变偏移
    changePosition: function (top, left) {
      if (this.maxscale === 1) {
        return
      }
      let _this = this
      // 0.67是上方 屏幕方向dom 部分偏移的部分 也是 .box margin-top 的50px
      // _this.top = top * (this.scale - 1) + 0.67
      _this.top = top * (this.scale - 1)
      _this.left = left * (this.scale - 1)
    },
    // 当缩放 放大的时候触发
    pinchout: function () {
      let _this = this
      if (_this.scale >= 0 && _this.scale < _this.maxscale) {
        _this.scale += 0.1
      }
    },
    // 当缩放 缩小的时候触发
    pinchin: function () {
      let _this = this
      if (_this.scale > 1) {
        _this.scale -= 0.1
      }
    },
    // 当手指拖动的过程中
    panmove: function (ev) {
      let _this = this
      if (_this.touchStatus) {
        // 本次座位图移动横纵坐标rem的值
        _this.top = (ev.deltaY + _this.startY) / _this.screenRem
        _this.left = (ev.deltaX + _this.startX) / _this.screenRem
        // .seatBox的高和缩略图的高 换算比例
        let heightProportion = (_this.seatBoxHeight * _this.seatScale / _this.thumbnailHeighthRem)
        // .seatBox的宽和缩略图的宽 换算比例
        let widthProportion = (_this.seatAreaWidthRem / _this.thumbnailWidthRem)
        // 本次缩略图移动横纵坐标rem的值
        _this.topthumbnail = -_this.top / heightProportion * _this.scalereciprocal
        _this.leftthumbnail = -_this.left / widthProportion * _this.scalereciprocal
      }
    },
    // 当手指拖动开始的时候
    panstart: function (ev) {
      let _this = this
      // 优化触摸性能
      _this.touchStatus = true
      // 展示缩略图
      _this.thumbnailShow = true
      // 获取上次记录的xy坐标作为起点
      _this.startY = _this.top * _this.screenRem
      _this.startX = _this.left * _this.screenRem
      clearTimeout(_this.timer)
    },
    // 当手指拖动结束的时候
    panend: function (ev) {
      let _this = this
      // 优化触摸性能
      _this.touchStatus = false
      if (_this.scale === 1) {
        _this.top = 0
        _this.left = 0
        _this.topthumbnail = 0
        _this.leftthumbnail = 0
      } else {
        // 如果宽度度移动超过了边界值 把移动置为边界值
        if (_this.left > _this.crossleft) {
          _this.left = _this.crossleft
        } else if (_this.left < -_this.crossleft) {
          _this.left = -_this.crossleft
        }
        // 缩略图移动超过了边界值 把移动置为边界值
        if (_this.leftthumbnail > _this.thumbnailWidthRemProportion) {
          _this.leftthumbnail = _this.thumbnailWidthRemProportion
        } else if (_this.leftthumbnail < -_this.thumbnailWidthRemProportion) {
          _this.leftthumbnail = -_this.thumbnailWidthRemProportion
        }
        // 如果高度移动超过了边界值 把移动置为边界值
        if (_this.top > _this.crosstop) {
          _this.top = _this.crosstop
        } else if (_this.top < -_this.crosstop) {
          _this.top = -_this.crosstop
        }
        // 缩略图移动超过了边界值 把移动置为边界值
        if (_this.topthumbnail > _this.thumbnailHeighthRemProportion) {
          _this.topthumbnail = _this.thumbnailHeighthRemProportion
        } else if (_this.topthumbnail < -_this.thumbnailHeighthRemProportion) {
          _this.topthumbnail = -_this.thumbnailHeighthRemProportion
        }
      }
      _this.timer = setTimeout(() => {
        _this.thumbnailShow = false
      }, 2000)
    }
  },
  computed: {
    // 最大放大比例
    maxscale: function () {
      return 1 + 1 / (this.seatScale * 2)
    },
    // 左边触边吸附边界值rem
    crossleft: function () {
      let _this = this
      return (_this.scale - 1) * _this.seatAreaWidthRem * 2.5 * _this.scaleXCross
    },
    // 上边触边吸附边界值rem
    crosstop: function () {
      let _this = this
      return (_this.scale - 1) * _this.seatAreaHeightRem * _this.scaleYCross
    },
    // scale的倒数
    scalereciprocal: function () {
      return 1 / this.scale
    },
    // 缩略图宽度触边吸附边界值
    thumbnailWidthRemProportion: function () {
      let _this = this
      return (1 - _this.scalereciprocal) * _this.thumbnailWidthRem / 2
    },
    // 缩略图高度触边吸附边界值
    thumbnailHeighthRemProportion: function () {
      let _this = this
      return (1 - _this.scalereciprocal) * _this.thumbnailHeighthRem / 2
    },
    // 每个座位放大后的高度
    seatHeightWithScale: function () {
      let _this = this
      return _this.seatHeight * _this.scale
    },
    // seat-tool 内的字体大小
    seatToolFontSize: function () {
      let fontsize = 20 / this.pxtorem
      return fontsize * this.scale
    },
    // seat-tool-item 的宽度
    seatToolWidthWithScale: function () {
      let _this = this
      return 0.2 * _this.scale
    },
    // 座位侧边栏需要偏移的长度
    seatToolMargin: function () {
      let _this = this
      let height = (_this.seatHeightWithScale * _this.yMax) * _this.scaleYCross * (_this.seatScale - 1)
      return _this.top + _this.seatHeightWithScale * _this.seatScale - _this.crosstop + height
    },
    // css样式控制.box缩放中心点
    transformOrigin: function () {
      return this.scaleXCross * 100 + '%' + this.scaleYCross * 100 + '%'
    },
    // css样式控制.seat-tool缩放中心点
    transformOriginTool: function () {
      return '0 ' + this.scaleYCross * 100 + '%'
    },
    // 缩放.box区域 x轴的中心点
    scaleXCross: function () {
      return (this.middleLine / this.seatAreaWidthRem) * this.seatScale
    },
    // 缩放.box区域 y轴的中心点
    scaleYCross: function () {
      return (this.horizontalLine / this.seatAreaHeightRem) * this.seatScale
    },

  },
  watch: {
    propThumbnailAreaWidth: function (value) {
      this.thumbnailWidthRem = value
    },
    propThumbnailAreaHeight: function (value) {
      this.thumbnailHeighthRem = value
    },
    propYMax: function (value) {
      this.yMax = value
    },
    propSeatScale: function (value) {
      this.seatScale = value
    },
    propMiddleLine: function (value) {
      this.middleLine = value
    },
    propHorizontalLine: function (value) {
      this.horizontalLine = value
    },
    propSeatBoxHeight: function (value) {
      this.seatBoxHeight = value
    },
    propSeatToolArr: function (value) {
      this.seatToolArr = value
    },
    propHallName: function (value) {
      if (this.propHallName.length > 0) {
        this.showTag = true
        // 使用 setTimeout 替代 setInterval，因为只需执行一次
        setTimeout(() => {
          this.showTag = false
        }, 5000)
      }
    },
  },
  mounted: function () {


  }
}
</script>

<style lang='scss' scoped="scoped">
.activity-area {
  position: relative;
  background: #f6f6f6;
  overflow: hidden;
}


.thumbnail {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  transform-origin: 0 0;
}

.thumbnail-border {
  position: absolute;
  z-index: 4;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 1px border-2px(red, 0);
}

.screen {
  width: 20rem;
  background: url('data:image/png;base64,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') no-repeat;
  // color white
  position: absolute;
  background-size: 100% auto;
  top: 5px;
  z-index: 2;
  left: 50%;
  color: #666;
  transform: translateX(-50%);
}

.screen-text {
  text-align: center;
  white-space: nowrap;
  margin: 0 1rem;
  font-size: 0.8rem;
  margin-top: 0.5rem;
  background-color: #333333DD;
  color: white;
  padding: 0.4rem 1rem 0.5rem 1rem;
  border-radius: 1rem;
}

.screen-text-top {
  width: 15rem;
  position: absolute;
  z-index: 3;
  left: 50%;
  color: #666;
  transform: translateX(-50%);
}

.screen-text-t {

  text-align: center;
  white-space: nowrap;
  font-size: 0.8rem;
  margin-top: 0.5rem;
  color: #666;
}

.box {
  position: absolute;
  z-index: 0;
  overflow: hidden;
  margin-top: 1.5rem;
}

.seat-tool-parent {
  overflow: hidden;
  margin-top: 1.5rem;
}

.seat-tool {
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1;
  left: 0.1rem;
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.3);
  text-align: center;
  color: white;
  font-weight: bold;
}

.seat-tool-item {
  padding: 0 0.2rem;

}
</style>
